import { orderBy } from 'lodash';
import Resources from '../../helpers/resources';
import { handleResourceError, handleResourceSuccess } from '../../helpers/resource-handlers';
import schoolIdActions from './school-id-actions';

export const CLASS_OVERVIEW_DATA_RETRIEVED = 'CLASS_OVERVIEW_DATA_RETRIEVED';

function getClassOverviewData(startDate, endDate, productId) {
    return dispatch => Resources
        .classOverview
        .get()
        .withParams({ productId, startDate, endDate })
        .send()
        .then(
            (payload) => {
                if (payload.data) {
                    const { classroomsUsageInfo, schoolId } = payload.data;

                    if (classroomsUsageInfo) {
                        dispatch(schoolIdActions.setSchoolId(schoolId));

                        return handleResourceSuccess(dispatch, payload, {
                            type: CLASS_OVERVIEW_DATA_RETRIEVED,
                            payload: {
                                data: classroomsUsageInfo.map(item => ({
                                    id: item.classId,
                                    class: item.className,
                                    teacher: mapTeachers(item.teachers),
                                    course: item.courseName,
                                    total: item.totalCertificates
                                }))
                            }
                        });
                    }
                }

                return handleResourceError(dispatch, payload.message);
            },
            error => handleResourceError(dispatch, error)
        );
}

function mapTeachers(teachers) {
    const teacherNames = teachers.map(teacher => teacher.teacherName);
    const sortedTeacherNames = orderBy(teacherNames, (teacherName) => {
        const names = teacherName.split(' ');
        return names[names.length - 1];
    });
    return sortedTeacherNames.join('\n');
}

export default {
    getClassOverviewData
};



// WEBPACK FOOTER //
// ./containers/overview/overview-actions.js